// Vuex user module mutations types
export const FILL_DETAILS = 'FILL_DETAILS';
export const FILL_RECORDS_CART = 'FILL_RECORDS_CART';
export const REMOVE_FROM_RECORDS_CART = 'REMOVE_FROM_RECORDS_CART';
export const CLEAR_RECORDS_CART = 'CLEAR_RECORDS_CART';
